export default __webpack_public_path__ + "static/media/pnc.8b9bd346.svg";